// Modal UX screens: tutorial, pause menu.

const MODAL_BASE = `
  position: fixed; left: 50%; top: 50%; transform: translate(-50%, -50%);
  background: rgba(8,12,20,.95); backdrop-filter: blur(8px);
  border: 1px solid rgba(255,255,255,.12);
  border-radius: 18px; padding: 24px 30px;
  font: 600 13px system-ui, sans-serif; color: #e2e8f0;
  box-shadow: 0 30px 80px rgba(0,0,0,.7);
  display: none;
  pointer-events: auto;
  max-width: 90vw; max-height: 85vh; overflow: auto;
  z-index: 150;
`;

// Tutorial overlay — re-exported from the newer intro_tutorial module so
// main.ts and PauseMenu.onTutorial keep working.
export { IntroTutorial as TutorialOverlay } from './intro_tutorial';

export class PauseMenu {
  el: HTMLDivElement;
  private volumeEl: HTMLInputElement;
  private cbEl: HTMLInputElement;
  onResume: () => void = () => undefined;
  onTutorial: () => void = () => undefined;
  onSwitchTeam: () => void = () => undefined;
  onSettings: () => void = () => undefined;
  onGoToLobby: () => void = () => undefined;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'ui interactive';
    this.el.style.cssText = MODAL_BASE + 'width: 360px;';
    this.el.innerHTML = `
      <div style="font:800 24px system-ui;margin-bottom:14px;">☰ Menu</div>
      <div style="font:600 10px system-ui;opacity:.55;letter-spacing:1px;margin:-10px 0 14px;">
        MP GAME CONTINUES — NO PAUSE
      </div>
      <div style="margin-bottom:14px;">
        <div style="font-size:11px;opacity:.6;letter-spacing:1px;margin-bottom:4px;">VOLUME</div>
        <input id="pause-vol" type="range" min="0" max="100" value="70" style="width:100%;" />
      </div>
      <div style="margin-bottom:18px;">
        <label style="display:flex;align-items:center;gap:8px;cursor:pointer;">
          <input id="pause-cb" type="checkbox" />
          <span>Colorblind mode (high contrast)</span>
        </label>
      </div>
      <button id="pause-settings" style="display:block;width:100%;margin-bottom:8px;background:rgba(253,224,71,.1);color:#fde047;border:1px solid #fde047;padding:10px;border-radius:8px;font:800 12px system-ui;cursor:pointer;letter-spacing:.5px;">⚙ Settings</button>
      <button id="pause-lobby" style="display:block;width:100%;margin-bottom:8px;background:rgba(96,165,250,.12);color:#93c5fd;border:1px solid #60a5fa;padding:10px;border-radius:8px;font:800 12px system-ui;cursor:pointer;letter-spacing:.5px;">🏠 Leave Match</button>
      <button id="pause-switch" style="display:block;width:100%;margin-bottom:8px;background:rgba(255,255,255,.07);color:#e2e8f0;border:0;padding:10px;border-radius:8px;font:700 12px system-ui;cursor:pointer;">Switch Team</button>
      <button id="pause-tutorial" style="display:block;width:100%;margin-bottom:8px;background:rgba(255,255,255,.07);color:#e2e8f0;border:0;padding:10px;border-radius:8px;font:700 12px system-ui;cursor:pointer;">Replay Tutorial</button>
      <button id="pause-resume" style="display:block;width:100%;background:#3b82f6;color:#fff;border:0;padding:10px;border-radius:8px;font:700 13px system-ui;cursor:pointer;">Close [Esc]</button>
    `;
    parent.appendChild(this.el);
    this.volumeEl = this.el.querySelector<HTMLInputElement>('#pause-vol')!;
    this.cbEl = this.el.querySelector<HTMLInputElement>('#pause-cb')!;
    this.el.querySelector<HTMLButtonElement>('#pause-resume')!.addEventListener('click', () => this.hide());
    this.el.querySelector<HTMLButtonElement>('#pause-tutorial')!.addEventListener('click', () => { this.hide(); this.onTutorial(); });
    this.el.querySelector<HTMLButtonElement>('#pause-switch')!.addEventListener('click', () => { this.hide(); this.onSwitchTeam(); });
    this.el.querySelector<HTMLButtonElement>('#pause-settings')!.addEventListener('click', () => { this.onSettings(); });
    this.el.querySelector<HTMLButtonElement>('#pause-lobby')!.addEventListener('click', () => { this.hide(); this.onGoToLobby(); });
    this.volumeEl.addEventListener('input', () => {
      const v = Number(this.volumeEl.value) / 100;
      localStorage.setItem('smp.volume', String(v));
    });
    this.cbEl.addEventListener('change', () => {
      localStorage.setItem('smp.cb', this.cbEl.checked ? '1' : '0');
      document.body.classList.toggle('cb-mode', this.cbEl.checked);
    });
    const vol = parseFloat(localStorage.getItem('smp.volume') ?? '0.7');
    this.volumeEl.value = String(Math.round(vol * 100));
    this.cbEl.checked = localStorage.getItem('smp.cb') === '1';
    if (this.cbEl.checked) document.body.classList.add('cb-mode');
  }

  show() { this.el.style.display = 'block'; }
  hide() { this.el.style.display = 'none'; this.onResume(); }
  isOpen(): boolean { return this.el.style.display !== 'none'; }
  volume(): number { return Number(this.volumeEl.value) / 100; }
  setInLobby(inLobby: boolean): void {
    const btn = this.el.querySelector<HTMLButtonElement>('#pause-lobby');
    if (btn) btn.style.display = inLobby ? 'none' : 'block';
  }
}
